<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormMaterial" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objMaterial.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="IdProductoCategoria">Categoría</label>
							<select v-model="objMaterial.IdProductoCategoria" class="form-control-search form-select" id="IdProductoCategoria">
								<option value="">Seleccione una Categoría</option>
								<option v-for="(item, index) in Categorias" :key="index" :value="item.IdProductoCategoria">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdProductoCategoria" :Mensaje="'*'+errorvalidacion.IdProductoCategoria[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="TipoMaterial">Tipo de Material</label>
							<select v-model="objMaterial.TipoMaterial" class="form-control-search form-select" id="TipoMaterial">
								<option value="">Seleccione una opción</option>
								<option value="Material">Material</option>
								<option value="Herramienta">Herramienta</option>
								<option value="Insumo">Insumo</option>
							</select>
							<CValidation v-if="this.errorvalidacion.TipoMaterial" :Mensaje="'*'+errorvalidacion.TipoMaterial[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Stock">Existencias</label>
							<input @input="$onlyNums($event,objMaterial,'Stock')" type="text" v-model="objMaterial.Stock" class="form-control" id="Stock" placeholder="Ingresar Existencias" />
							<CValidation v-if="this.errorvalidacion.Stock" :Mensaje="'*'+errorvalidacion.Stock[0]"/>
						</div>
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="MinimoStock">Stock Mínimo</label>
							<input @input="$onlyNums($event,objMaterial,'MinimoStock')" type="text" v-model="objMaterial.MinimoStock" class="form-control" id="MinimoStock" placeholder="Ingresar MinimoStock" />
							<CValidation v-if="this.errorvalidacion.MinimoStock" :Mensaje="'*'+errorvalidacion.MinimoStock[0]"/>
						</div>
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="MaximoStock">Stock Maximo</label>
							<input @input="$onlyNums($event,objMaterial,'MaximoStock')" type="text" v-model="objMaterial.MaximoStock" class="form-control" id="MaximoStock" placeholder="Ingresar MaximoStock" />
							<CValidation v-if="this.errorvalidacion.MaximoStock" :Mensaje="'*'+errorvalidacion.MaximoStock[0]"/>
						</div>
					</div>
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormMaterial',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objMaterial: {
				IdMaterial: 0,
				Nombre: '',
				IdProductoCategoria: "",
				Stock: 0,
				StockReal:0,
				MinimoStock: 0,
				MaximoStock: 0,
				TipoMaterial: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Categorias:[]
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objMaterial.IdMaterial == 0) {
				await this.$http.post(
					'materiales',this.objMaterial
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'materiales/'+this.objMaterial.IdMaterial,
					this.objMaterial
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "materiales/"+this.objMaterial.IdMaterial
            ).then((res) => {
                this.objMaterial = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objMaterial.Fecha.replace(/-/g,'\/');
                this.objMaterial.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objMaterial = {
				IdMaterial: 0,
				Nombre: '',
				IdProductoCategoria: "",
				Stock: 0,
				MinimoStock:0,
				MaximoStock:0,
				IdEmpresa: 0,
				IdSucursal: 0,
				TipoMaterial: '',
				
            }
            this.errorvalidacion = [];
        },
		ListaCategorias()
		{
			this.$http.get('productosCategoria/simple',{
				params:{
				}
			}).then((res)=>{
                this.Categorias = res.data.data;
			})
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            // $('.vue-treeselect__menu-container').css('z-index','9999999');
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
			this.ListaCategorias();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objMaterial.IdMaterial = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
